import { HttpContext, HttpContextToken } from "@angular/common/http";

/** Opt-out for requests whose failures are already reported to the user by a specific error UI. */
export const SKIP_GLOBAL_ERROR = new HttpContextToken<boolean>(() => false);

export const skipGlobalError = (context = new HttpContext()): HttpContext => context.set(SKIP_GLOBAL_ERROR, true);
